import { Directive, DoCheck, Optional, QueryList, ContentChildren, Self, AfterContentInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageComponent } from '../message/message.component';
import { MessagesComponent } from '../messages/messages.component';
import { isNullOrUndefined } from 'util';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'jhi-messages'
})
export class ValidationDirective implements DoCheck, AfterContentInit {

  @ContentChildren(MessageComponent)
  messages: QueryList<MessageComponent>;

  constructor(@Optional() private form: NgForm, @Self() @Optional() private messagesComponent: MessagesComponent) { }

  ngAfterContentInit(): void {
    // reset
    this.messages.changes.subscribe(_ => this.messagesComponent.isInvalid = false);
  }

  ngDoCheck(): void {
    if (this.messages) {
      const controls = this.messages.map(message => message.controlKey);
      if (controls.some(controlKey => !isNullOrUndefined(this.form.controls[controlKey]))) {
        this.displayMessages();
      }
    }
  }

  displayMessages(): any {
    this.messagesComponent.isInvalid = false;

    this.messages.forEach(messageComponent => {
      messageComponent.isInvalid = false;
      if (this.form.controls[messageComponent.controlKey]) {
            const errorKeys = this.getErrorKeys(messageComponent.controlKey);

            messageComponent.isInvalid = this.isTouched(messageComponent.controlKey) &&
              errorKeys.some(key => key === messageComponent.error);

            this.messagesComponent.isInvalid = this.messagesComponent.isInvalid || messageComponent.isInvalid;

            if (this.form.submitted && this.messagesComponent.isInvalid) {
              this.form.controls[messageComponent.controlKey].markAsTouched();
            }
      }

    });
  }

  private isTouched(controlKey: string) {
    return this.form.controls[controlKey].touched || this.form.controls[controlKey].dirty;
  }

  private getErrorKeys(controlKey: string) {
    return Object.keys(this.form.controls[controlKey].errors || {});
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/directives/validation.directive.ts